import { StringField } from "../../../types/types";
import { CardsLayout, ContactCards, ContactCardsProps } from "../types/ContactCards.types";

export class ContactCardsModel {
  private readonly fields?: ContactCards;
  constructor(props: ContactCardsProps) {
    this.fields = props.fields;
  }

  get contactCards(): ContactCards | undefined {
    return this.fields ;
  }

  get variant(): StringField | undefined {
    return this.fields?.Variant;
  }

  get columnLayout(): string {
    return CardsLayout[this.fields?.ColumnLayout?.fields?.Key?.value || '3ColumnLayout'];
  }
}
